import { Component, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-pagenotfound',
    templateUrl: './pagenotfound.component.html'
})
export class PageNotFoundComponent {

    protected translate = inject(TranslateService);
}
